// Game Configuration - 游戏配置
export const DEFAULT_STARTING_ITEMS = {
  '灵草': 100,
  '灵石': 100,
  '铁矿': 100,
  '玉石': 100
};

export const DEFAULT_STARTING_SKILLS = {
  '炼丹术': true,
  '炼器术': true
};

export const RANDOM_NAMES = [
  '无名',
  '少侠',
  '李青云',
  '风清扬',
  '白惊鸿',
  '张无忌',
  '赵灵儿',
  '林惊羽',
  '苏婉儿',
  '慕容雪'
];
